
import React, { Component } from 'react'
import styled from 'styled-components'
import { MenuItem } from 'react-aria-menubutton';
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Desktop, Mobile }  from '../../../media'
import { NavLink } from 'react-router-dom'

import ChangeLanguageImage from '../../../images/globe.svg';
import InfoImage from '../../../images/info.svg';
import ImpersonateUserImage from '../../../images/impersonate.png';
import StopImpersonationUserImage from '../../../images/stop-impersonation.png';

import employeeService from '../../../services/Employee.service'
import {UserRoles} from '../../../constants'

const Wrapper = styled.ul`
    list-style-type: none;
    margin: 0px;
    padding: 0px;

    > li {
        border-bottom: 1px solid #DDDDDD;
        padding: 15px;
        margin: 0px;

        > div[role=menuitem], > button {
            white-space: nowrap;
            padding-left: 28px;
            font-family: Lato-Regular;
            font-size: 14px;
            color: #2B2B2B;
            line-height: 22px;
            text-decoration: none;
            cursor: pointer;
            width: 100%;
            text-align: left;
            background-repeat: no-repeat;
            border: none;
            background-color: transparent;
        }

    }
`

class UserMenuItems extends Component {

    // exit the mobile menu when tabbing off the last item (the "About" item)
    onAboutKeyPress = (event) => {
        switch (event.keyCode) {
        case 9: // TAB
            if (this.props.exitFunc && !event.shiftKey){
                this.props.exitFunc();
                event.stopPropagation();
                event.preventDefault();
            }
            break;

        default:
            break;
        }
    }

    render() {
        const {t, employee } = this.props

        const UserMenuItem = ({ className, index, title, onKeyDown, backgroundImageUrl }) => (
            <li className={className}>
                {onKeyDown &&
                    <button type="button" aria-haspopup={true} onClick={() => this.props.onUserMenuSelection(index)} onKeyDown={onKeyDown} style={{backgroundImage: `url(${backgroundImageUrl})`}}>
                        {title}
                    </button>
                }
                {!onKeyDown &&
                    <button type="button" aria-haspopup={true} onClick={() => this.props.onUserMenuSelection(index)} style={{backgroundImage: `url(${backgroundImageUrl})`}}>
                        {title}
                    </button>
                }
            </li>
        )

        return (
            <Wrapper>
                {!employeeService.hasRole(employee.roles, UserRoles.IMPERSONATED) &&
                    <UserMenuItem className="change-language-menu-item" index={0} title={t('Navigation.ChangeLanguage')} backgroundImageUrl={ChangeLanguageImage}/>
                }
                {employeeService.hasRole(employee.roles, UserRoles.IMPERSONATE) &&
                    !employeeService.hasRole(employee.roles, UserRoles.IMPERSONATED) &&
                    <UserMenuItem className="impersonate-menu-item" index={1} title={t('Navigation.ImpersonateUser')} backgroundImageUrl={ImpersonateUserImage}/>
                }
                {employeeService.hasRole(employee.roles,UserRoles.IMPERSONATED) &&
                    <UserMenuItem className="stop-menu-item" index={2} title={t('Navigation.StopImpersonation')} backgroundImageUrl={StopImpersonationUserImage}/>
                }
                <UserMenuItem  className="about-menu-item" index={3} title={t('Navigation.About')} onKeyDown={this.onAboutKeyPress} backgroundImageUrl={InfoImage}/>
            </Wrapper>
        )
    }
}

const mapState = state => ({
    employee: state.employee
})

export default connect(mapState)(withTranslation('translations')(UserMenuItems))
